import { render, staticRenderFns } from "./billing-rates.vue?vue&type=template&id=65b2780c&"
import script from "./billing-rates.vue?vue&type=script&lang=js&"
export * from "./billing-rates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports